import { ValidationModel } from "../../core/model/validation_model";
import { Type } from "class-transformer";
import { Allow, ArrayNotEmpty, IsArray, IsBoolean, IsDefined, IsEnum, IsIn, IsMongoId, IsNotEmpty, IsNumber, IsObject, IsOptional, IsString, Min, ValidateBy, ValidateNested } from "class-validator";

export enum TypesTasks {
  onlyNumber = "onlyNumber",
  onlyText = "onlyText",
  oneOfSeveral = "oneOfSeveral",
  severalOSeveral = "severalOSeveral",
}

export class TaskCore extends ValidationModel {
  @IsEnum(TypesTasks)
  type: TypesTasks;
  @IsOptional()
  @IsString()
  description?: string;
  @IsOptional()
  @IsString()
  solution?: string;
  @IsString()
  @IsNotEmpty()
  title: string = "";
}

export class TaskSeveralRadio {
  @IsBoolean()
  isRight: boolean;
  @IsString()
  @IsNotEmpty()
  text: string;
}

function CorrectAnswers(single: boolean) {
  return ValidateBy({ name: "correctAnswers", validator: {
    validate: (answers: unknown) => Array.isArray(answers) &&
      (single ? answers.filter(a => a?.isRight === true).length === 1 : answers.some(a => a?.isRight === true)),
    defaultMessage: () => single ? "answers must contain exactly one correct option" : "answers must contain at least one correct option",
  }});
}

export class TaskOnlyText extends TaskCore {
  @IsIn([TypesTasks.onlyText])
  type = TypesTasks.onlyText;
  @IsArray()
  @ArrayNotEmpty()
  @IsString({ each: true })
  @IsNotEmpty({ each: true })
  answers: string[] = [];
}
export class TaskOnlyNumber extends TaskCore {
  @IsIn([TypesTasks.onlyNumber])
  type = TypesTasks.onlyNumber;
  @IsArray()
  @ArrayNotEmpty()
  @IsNumber({ allowNaN: false, allowInfinity: false }, { each: true })
  answers: number[] = [];
}
export class TaskOneOfSeveral extends TaskCore {
  @IsIn([TypesTasks.oneOfSeveral])
  type = TypesTasks.oneOfSeveral;
  @IsArray()
  @ArrayNotEmpty()
  @ValidateNested({ each: true })
  @Type(() => TaskSeveralRadio)
  @CorrectAnswers(true)
  answers: TaskSeveralRadio[] = [];
}
export class TaskSeveralOSeveral extends TaskCore {
  @IsIn([TypesTasks.severalOSeveral])
  type = TypesTasks.severalOSeveral;
  @IsArray()
  @ArrayNotEmpty()
  @ValidateNested({ each: true })
  @Type(() => TaskSeveralRadio)
  @CorrectAnswers(false)
  answers: TaskSeveralRadio[] = [];
}

export const taskTypeOptions = {
  discriminator: { property: "type", subTypes: [
    { value: TaskOnlyText, name: TypesTasks.onlyText },
    { value: TaskOnlyNumber, name: TypesTasks.onlyNumber },
    { value: TaskOneOfSeveral, name: TypesTasks.oneOfSeveral },
    { value: TaskSeveralOSeveral, name: TypesTasks.severalOSeveral },
  ] }, keepDiscriminatorProperty: true,
};

export class TaskValidationModel extends ValidationModel {
  @IsOptional()
  @IsMongoId()
  _id?: string;
  @Allow()
  __v?: number;
  @IsIn(["draft", "published"])
  status: "draft" | "published" = "draft";
  @IsBoolean()
  randomEligible: boolean = true;
  @IsNumber({ allowNaN: false, allowInfinity: false })
  @Min(0)
  scoreAmount: number = 0;
  @IsArray()
  @IsString({ each: true })
  @IsNotEmpty({ each: true })
  tags: string[] = [];
  @IsDefined()
  @IsObject()
  @ValidateNested()
  @Type(() => TaskCore, taskTypeOptions)
  task: TaskOnlyText | TaskOnlyNumber | TaskOneOfSeveral | TaskSeveralOSeveral;
}
